export default __webpack_public_path__ + "static/media/add2.fcc0b433.svg";